<template>
    <edit-string
        ref="input"
        v-model="inputValue"
        form
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :label="labelValue || $t('month')"
        :placeholder="'MM'"
    />
</template>

<script>
import BaseField from './BaseField';
export default {
    name: 'Month',
    extends: BaseField,
    mounted() {
        this.rulesArray = [v => this.getValidator('month')(v, this.labelValue || this.$t('month'))];
    }
};
</script>
